import React from "react";
import style from "./style.module.css";

const SectionHeader = (props: any) => {
  return (
    <div className={style.copyWrapper}>
      <h1 className={props.white ? style.alternateHeader : ""}>
        {props.header}
      </h1>
      {props.subHeader ? <p>{props.subHeader}</p> : null}
      <div className={style.coloredSpacer}></div>
    </div>
  );
};

export default SectionHeader;
